var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.election && _vm.breakpoint.less('sm'))?_c('MobileLayout',{attrs:{"election":_vm.election}}):(_vm.election && _vm.breakpoint.greaterEquals('sm'))?_c('DesktopLayout',{attrs:{"election":_vm.election}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }